module.exports = __webpack_public_path__ + "static/media/spinner.9cf766ef.gif";